import { render, staticRenderFns } from "./HowToKnowItemComponent.vue?vue&type=template&id=2449d5b5"
import script from "./HowToKnowItemComponent.vue?vue&type=script&lang=js"
export * from "./HowToKnowItemComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports